import { Navigate, useLocation, useNavigate } from "react-router-dom"
import useAuth from "../auth/hooks/useAuth"
const Unauthorized = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const goBack = () => navigate(-1);
    const { auth } = useAuth();
    return auth?.isAuthenticated ? (
        <section>
            <h1>Unauthorized</h1>
            <br />
            <p>You do not have access to the requested page.</p>
            <div className="flexGrow">
                <button onClick={goBack}>Go Back</button>
            </div>
        </section>
    ):(<Navigate to="/login " state={{from: location}} replace/>)
}
export default Unauthorized